export default __webpack_public_path__ + "static/media/HTMLCircularBackground-light-sepia-enlarged-700px.37e3907d.jpg";